import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import API from "../../../api";
import "./ProductSuggestionRow.css";

const TITLES = [
  {
    title: "Trending Products",
    subtitle: "Most popular construction materials"
  },
  {
    title: "Civilink Picks",
    subtitle: "Recommended materials for your project"
  },
  {
    title: "Construction Essentials",
    subtitle: "Quality products from trusted vendors"
  },
  {
    title: "Featured Products",
    subtitle: "Discover the latest additions"
  }
];

export default function ProductSuggestionRow() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  const heading = useMemo(
    () => TITLES[Math.floor(Math.random() * TITLES.length)],
    []
  );

  useEffect(() => {
    loadProducts();
  }, []);

  async function loadProducts() {
    try {
      const res = await API.get("/admin/products/home");

      if (res.data.success) {
        setProducts(res.data.products);
      }
    } catch (err) {
      console.error(err);
    }
  }

  if (!products.length) return null;

  return (
    <section className="home-product-row">

      <div className="home-product-row-header">

        <div>
          <h3>{heading.title}</h3>
          <p>{heading.subtitle}</p>
        </div>

        <button
          className="home-view-all-btn"
          onClick={() => navigate("/vendor")}
        >
          View All
        </button>

      </div>

      <div className="home-product-scroll">

        {products.map((product) => {

          const price =
            product.price ??
            product.variants?.[0]?.price ??
            product.variants?.[0]?.dailyPrice ??
            "";

          const isNew =
            Date.now() -
              new Date(product.createdAt).getTime() <
            1000 * 60 * 60 * 24 * 14;

          return (
            <div
              key={product._id}
              className="home-product-card"
              onClick={() => navigate("/vendor")}
            >

              <div className="home-product-image-box">

                <img
  src={product.imageUrl}
  alt={product.name}
  onError={(e) => {
    e.target.style.display = "none";
  }}
/>

                <div className="home-product-chip">
                  <Sparkles size={12} />
                  {isNew ? "New" : "Trending"}
                </div>

                <div className="home-product-featured">
                  Featured
                </div>

              </div>

              <div className="home-product-info">

                <div className="home-product-category">
                  {product.category}
                </div>

                <h4 className="home-product-name">
                  {product.name}
                </h4>

                <div className="home-product-price">
                  ₹{price}
                  {product.unit && (
                    <span> / {product.unit}</span>
                  )}
                </div>

                <button
                  className="home-product-view-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/vendor");
                  }}
                >
                  View Products
                  <ArrowRight size={16} />
                </button>

              </div>

            </div>
          );
        })}

      </div>

    </section>
  );
}